import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button, Drawer, Typography, Switch } from "antd";
import { ReloadOutlined, UserOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useRefresh } from "../../RefreshContext";
import { Avatar } from "antd";
import userimage from "../../assets/images/userimage.jpg";

// Styled Components
const ButtonContainer = styled.div`
  .ant-btn-primary {
    background-color: #1890ff;
  }
  .ant-btn-success {
    background-color: #52c41a;
  }
  .ant-btn-yellow {
    background-color: #fadb14;
  }
  .ant-btn-black {
    background-color: #262626;
    color: #fff;
    border: 0px;
    border-radius: 5px;
  }
  .ant-switch-active {
    background-color: #1890ff;
  }
`;

const RefreshBox = styled.div`
  background-color: white;
  padding: 8px 16px;
  border-radius: 12px;
  width: 420px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-top: -9px; /* move box slightly up */
`;

// Sidebar toggler icon
const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

// Helper: format current date as "Month Day, Year" (e.g. "July 14, 2025")
function formatDate() {
  const now = new Date();
  return now.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

function Header({
  darkMode,
  onThemeChange,
  placement,
  name,
  subName,
  onPress,
  handleSidenavColor,
  handleSidenavType,
  handleFixedNavbar,
  sidenavType,
  sidenavColor,
}) {
  const { Title } = Typography;
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const { triggerRefresh } = useRefresh();
  const username = Cookies.get("username");

  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);

    const updateClock = () => {
      const now = new Date();
      setCurrentTime(now.toLocaleTimeString());
    };

    updateClock(); // initial set
    const interval = setInterval(updateClock, 1000);
    return () => clearInterval(interval);
  }, []);

  const showDrawer = () => setVisible(true);
  const hideDrawer = () => setVisible(false);

  return (
    <>
      <Row
        gutter={[24, 0]}
        style={{
          background: sidenavType,
          transition: "background 0.3s ease",
          padding: "0 16px",
          alignItems: "center",
        }}
      >
        {/* Greeting */}
        <Col span={24} md={6}>
          <div className="ant-page-header-heading mt-2">
            <Title
              level={4}
              style={{
                margin: 0,
                color: "#ffffff",
                fontWeight: "bold",
                marginLeft: "50px",
              }}
            >
              Hi {username}!
            </Title>
          </div>
        </Col>

        {/* Controls */}
        <Col
          span={24}
          md={18}
          className="header-control"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "4px 16px",
          }}
        >
          {/* Sidebar toggler on the left */}
          <Button
            type="link"
            className="sidebar-toggler"
            onClick={() => onPress()}
          >
            {toggler}
          </Button>

          {/* Refresh Box on the right */}
          <RefreshBox
            style={{
              width: "420px",
              maxWidth: "100%",
              marginTop: "-9px",
              padding: "12px 16px",
              height: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {/* Left: Date and Time */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                lineHeight: 1,
                gap: "6px",
                flex: 1,
              }}
            >
              <span
                style={{
                  fontSize: "0.98rem",
                  fontWeight: "600",
                  color: "#1f1f1f",
                  userSelect: "none",
                }}
              >
                {formatDate()}
              </span>
              <span
                style={{
                  fontSize: "0.85rem",
                  color: "#666",
                  userSelect: "none",
                }}
              >
                {currentTime}
              </span>
            </div>

            {/* Middle: Refresh Button */}
            <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
              <Button
                onClick={triggerRefresh}
                type="primary"
                style={{
                  backgroundColor: "#0D2481",
                  borderColor: "#0D2481",
                  color: "white",
                  borderRadius: "8px",
                  padding: "0 12px",
                  minWidth: "70px",
                  height: "35px",
                  lineHeight: "32px",
                }}
              >
                Refresh
              </Button>
            </div>

            <label className="theme-toggle" htmlFor="dashboard-theme-switch">
              <span>{darkMode ? "Night" : "Day"}</span>
              <Switch
                id="dashboard-theme-switch"
                checked={darkMode}
                onChange={onThemeChange}
                checkedChildren="☾"
                unCheckedChildren="☀"
                aria-label="Night theme"
              />
            </label>

            {/* Right: Avatar */}
            {/* <div
              style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}
            >
              <Avatar
                src={userimage}
                size={50}
                icon={<UserOutlined />}
                style={{ cursor: "pointer" }}
              />
            </div> */}
          </RefreshBox>
        </Col>
      </Row>
    </>
  );
}

export default Header;
